import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getPendingMerges, reportOrderMatch, cancelReportOrder } from '../../../actions/reports'
import { closeOverlay } from '../../../actions/common'

// Elements
import Overlay from '../../elements/overlay'

// Components
import Matching from './matching'
import OverlayHeaderBare from '../../components/OverlayHeaderBare'

import { translation } from '../../../utils/helpers'

// Misc.
import './reportMerge.scss'

class ReportMergeOverlay extends Component {
  constructor (props) {
    super(props)
    this.state = {
      title: '',
      targets: [],
      sources: [],
      isLoading: true
    }

    this.renderHeader = this.renderHeader.bind(this)
    this.handleOnMatch = this.handleOnMatch.bind(this)
    this.handleResponseData = this.handleResponseData.bind(this)
    this.handleOnCancallation = this.handleOnCancallation.bind(this)
    this.getMerges = this.getMerges.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (!this.props.item) return

    if (JSON.stringify(this.props.item) !== JSON.stringify(prevProps.item)) {
      this.getMerges()
    }
  }

  getMerges () {
    this.setState({ title: '', targets: [], sources: [], isLoading: true })
    this.props.getPendingMerges(this.props.item.OrderId).then(res => {
      let { Sources, Targets, Title } = res.data
      this.setState({
        title: Title,
        sources: Sources,
        targets: Targets,
        isLoading: false
      })
    }).catch(_ => window.toastr.error(translation('2269'), translation('216')))
  }

  handleOnMatch (data) {
    this.props.reportOrderMatch(data)
    .then(res => {
      // window.toastr.success(translation('18078'), translation('13424'))
      this.handleResponseData(res.data)
    })
    .catch(_ => window.toastr.error(translation('18068'), translation('216')))
  }

  handleOnCancallation (data) {
    this.props.cancelReportOrder(data)
    .then(res => {
      // window.toastr.success(translation('18080'), translation('13424'))
      this.handleResponseData(res.data)
    })
    .catch(_ => window.toastr.error(translation('18081'), translation('216')))
  }

  handleResponseData (data) {
    let { Sources, Targets, Title } = data
    if (Sources.length === 0) this.props.closeOverlay('ReportMergeOverlay')

    this.setState({
      title: Title,
      sources: Sources,
      targets: Targets
    })
  }

  renderHeader () {
    return (
      <OverlayHeaderBare overlayId='ReportMergeOverlay' custom>
        <div className='top topHeaderInfo'>
          <div className='title'>
            <span>{this.state.title}</span>
          </div>
        </div>
      </OverlayHeaderBare>
    )
  }

  render () {
    let { sources, targets, isLoading } = this.state

    return (
      <Overlay overlayId='ReportMergeOverlay' extraClassName='report-merge-overlay'>
        {this.renderHeader()}
        <Matching
          isLoading={isLoading}
          targets={targets}
          sources={sources}
          onMatch={this.handleOnMatch}
          onCancallation={this.handleOnCancallation}
        />
      </Overlay>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    headerInfo: state.common.headerInfo
  }
}

export default connect(mapStateToProps, {
  getPendingMerges,
  reportOrderMatch,
  cancelReportOrder,
  closeOverlay
})(ReportMergeOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/ReportMerge/index.js